import { memo } from 'react';

import CircularProgress from '@mui/material/CircularProgress';

export default memo(function LoadingIndicator({ centered, ...rest }) {
  const loader = <CircularProgress {...rest} />;

  return centered ? <div style={{ textAlign: 'center' }}>{loader}</div> : loader;
});
